/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  .  .  .  . .  .  . .  .
    *    .       .       .       .       .       .       .       .       .       .       .       .
    *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
    *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
    *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
    *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
    *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
    *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
    *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
    *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
    *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
    *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
    *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
    *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
    *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
    *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *
 * Copyright FortyFix(c) 2024.
 * Title: Accessori.ts;
 * Path: ./src/environments/Modules/Accessori.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 20/05/25, 10:10;
 * Updated at: 20/05/25, 10:10;
 *
 */

export var Accessori = () => {

    var env = {
        Modules: {
            "Prodotti": true,
        },
        ProdottiAddOn: {
            SezioniCodiciSconto: [
                {
                    sezione: '',
                    campi: [
                        {
                            oggetti: ['prodotto'],
                            modificabile: true,
                            nome: 'Prodotto',
                            inputType: 'text',
                            titleClass: 'control-label col-form-label',
                            class: 'col-md-3',
                            visibleifProhibited: true
                        },
                        {
                            oggetti: ['magazzino'],
                            modificabile: false,
                            nome: 'Stock',
                            inputType: 'text',
                            titleClass: 'control-label col-form-label',
                            class: 'col-md-3',
                            visibleifProhibited: true
                        },
                        {
                            source: "/prodotti/magazzini/movimentazioni/list",
                            parameter: [{ nome: "page", value: 0 }, { nome: "size", value: 200 }, { nome: "prodotto_id", parameter: "id" }],
                            nome: 'Movimentazioni',
                            oggetti: ['movimentazioni'],
                            type: "table",
                            /* ExternalAddClick: 'movimentazioneAdd',*/
                            hideif: { fieldnotexist: 'id' },
                            header: [
                                { nome: "Magazzino Ingresso", oggetti: ['mag_ingresso'], style: { 'margin-left': '10px' }, },
                                { nome: "Magazzino Uscita", oggetti: ['mag_uscita'], style: { 'margin-left': '10px' }, },
                                { nome: "Data", oggetti: ['created_at'], inputType: 'datetime-local', style: { 'margin-left': '10px' }, },
                                { nome: "Descrizione", oggetti: ['descrizione'], style: { 'margin-left': '10px' }, },
                                { nome: "Quantita", oggetti: ['qta'], style: { 'margin-left': '10px' }, },
                            ],
                            responseHasData: true,
                            modificabile: true,
                            class: 'col-lg-12',
                        }
                    ],
                },

            ],
        },
        Menu: [
            {
                module: "Prodotti",
                path: "progetti/codicisconto/69/lista",
                title: 'menu.accessori',
                icon: "mdi mdi-barcode-scan",
                capacita: ["menu-prodotti"]
            },
        ],
    };
    return env;
}